import React from "react";

export default function LoanPromoSection() {
  return (
    <section className="font-serif bg-gray-100 text-center py-16">
      <h2 className="text-3xl md:text-4xl font-semibold text-gray-800 mb-4">
        Get a Loan
      </h2>
      <p className="text-gray-600 text-lg max-w-2xl mx-auto px-4">
        We’re here to help you achieve your dreams! Get a loan{" "}
        <span className="font-semibold text-gray-700">within 2 hours</span>.{" "}
        <span className="font-bold text-gray-700">Apply NOW!</span>
      </p>
    </section>
  );
}
